// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Services
import userService from "@/app/services/main/user/user-service.js"

// Third Party libraries
import * as $ from "jquery"

// Constants
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants"

export default {
	name: "ModalTransferPrimaryUser",
	mixins: [toastMessageMixins, tableMixins, userMixins],
	data() {
		return {
			isAPILoading: false,
			searchMember: "",
			membersThatAreNotActive: [],
			isGetMembersLoading: false,
			desc: true,
		}
	},
	beforeDestroy() {
		this.closeModal()
	},
	methods: {
		openModal() {
			$(this.$refs.modalTransferPrimaryUser).modal("show")
			this.searchMember = ""
			this.columnsFilter = {}
			this.getTableContent()
		},
		closeModal() {
			$(this.$refs.modalTransferPrimaryUser).modal("hide")
		},
		transferPrimaryAdmin(customerId) {
			this.$emit("transferPrimaryAdmin", customerId)
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page

			this.getMembersList({ page: this.page, limit: this.limit, sortBy: this.sortBy, desc: this.desc })
		},
		refreshTable() {
			this.$emit("getTableContent")
			this.closeModal()
		},
		getMembersList(queryParams) {
			const { customerId, id } = this.getUserDetails()

			queryParams["f_customerId"] = customerId
			queryParams.f_status = "ACTIVE"

			if (this.columnsFilter["f_name"]) {
				queryParams["f_firstName"] = this.columnsFilter["f_name"]
			}

			this.isGetMembersLoading = true

			userService.getUserList(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					let data = res.data.data
					let pagination = res.data.pagination
					if (res.data.data.length != 0) {
						if (data[0].id === id) {
							data.shift()
							pagination.totalCount = pagination.totalCount - 1
						}
					}

					this.tableContent = {
						tableData: data,
						paginationData: pagination,
					}
					this.isGetMembersLoading = false
				} else {
					this.showGenericErrorToast()
				}
			})
		},
		transferPrimaryUser(user) {
			const title = `Are you sure you want to transfer primary access to ${user.firstName} ${user.lastName}?`

			const toastContent = `Successfully transfered to ${user.firstName} ${user.lastName}!`

			this.$swal({
				imageHeight: "30px",
				title,
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					userService.putTransferUser(user.id).then((res) => {
						if (res.status === STATUS_CODES.SUCCESS) {
							this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, toastContent)
							this.refreshTable()
						} else {
							this.showGenericErrorToast()
						}
					})
				}
			})
		},
	},
}
